<script setup lang="ts">
import { normalizeFieldText } from '~/composables/useCustomFields'

const props = defineProps<{ year: number; month?: number }>()
const route = useRoute()
const blogApi = useBlogApi()
const siteData = await useSiteData()
const siteBaseUrl = resolveSiteBaseUrl(siteData?.setting?.customFields)
const page = computed(() => Math.max(1, Number(route.query.page || 1)))
const archiveLabel = computed(() => props.month
  ? `${props.year}-${String(props.month).padStart(2, '0')}`
  : String(props.year)
)
const description = computed(() => `${archiveLabel.value} ${props.month ? '月份' : '年度'}文章归档`)

const { data } = await useAsyncData(
  () => `archives:${archiveLabel.value}:${page.value}`,
  () => blogApi.getContentMetaList({ page: page.value, pageSize: 10, type: 'post', year: props.year, month: props.month })
)

const siteName = normalizeFieldText(siteData?.setting?.customFields, 'siteName')

useSeoMeta({
  title: () => `${archiveLabel.value} 归档 - ${siteName}`,
  description,
  ogTitle: () => `${archiveLabel.value} 归档 - ${siteName}`,
  ogDescription: description
})

useHead(() => ({
  link: [{ rel: 'canonical', href: `${siteBaseUrl}${route.path}` }]
}))
</script>

<template>
  <section class="archive-list-page">
    <div class="card header-card">
      <NuxtLink to="/archives" class="back-link">
        <i class="fa-solid fa-arrow-left" aria-hidden="true" />返回归档
      </NuxtLink>
      <h1>{{ archiveLabel }} 归档</h1>
      <p>共 {{ data?.total || 0 }} 篇文章</p>
    </div>

    <template v-if="data?.list.length">
      <BlogPostCard v-for="item in data.list" :key="item.ID" :item="item" />
      <BlogPager :page="page" :page-size="data?.pageSize || 10" :total="data?.total || 0" />
    </template>

    <div v-else class="empty-card">该归档暂无文章</div>
  </section>
</template>

<style scoped>
.archive-list-page {
  display: grid;
}

.header-card {
  padding: 20px;
  margin-bottom: 14px;
  background:
    radial-gradient(circle at 20% 0, color-mix(in srgb, var(--brand) 18%, transparent), transparent 56%),
    var(--bg-soft);
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: var(--text-soft);
  text-decoration: none;
}

h1 {
  font-size: var(--heading-title-size);
}

p {
  margin-top: 8px;
  color: var(--text-soft);
}
</style>
